const SysOptionGoodsGroupPluginSettings: IPluginSettings = {
    name: 'Группы номенклатур',
    mnemocode: 'sys_option_goods_group_plugin',
    permission: 'Goods',
    columns: [{
        order: 0,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'IdGlobal',
        visibility: false,
        width: 150
    },
    {
        order: 1,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 350
    },
    {
        order: 2,
        propertyName: 'comment',
        propertyType: 'string',
        displayName: 'Комментарий',
        visibility: true,
        width: 150
    },
    ],
}

export default SysOptionGoodsGroupPluginSettings
